import type { DeviceType } from '$lib/constants';
import { massToGrams } from '$lib/RLogUtils';
import {
  MassScale,
  type NewRoast,
  type NewRoastEvent,
  type RoastQueueItem,
  type Roastable,
  type TimeTempPair,
  type UserProfile
} from '$lib/types/RoastLog';

export interface PrepareRoastDeps {
  queueItem: RoastQueueItem;
  roastNotes: string;
  userProfile: UserProfile | null;
  recordedTemps: number[][];
  burner: TimeTempPair[];
  recordedTimes: number[];
  roastEvents: NewRoastEvent[];
  deviceType: DeviceType;
  selectedRoaster: {
    roasterId: string;
    massScale: MassScale;
    tcLabels: {
      tc2: string | null;
      tc3: string | null;
      tc4: string | null;
    };
  };
  selectedLocation: string;
}

export const prepareNewRoast = (id: string, deps: PrepareRoastDeps): NewRoast => {
  const {
    queueItem,
    roastNotes,
    userProfile,
    recordedTemps,
    burner,
    recordedTimes,
    roastEvents,
    deviceType,
    selectedRoaster,
    selectedLocation
  } = deps;

  const roastable = $state.snapshot((queueItem.roastable = queueItem.roastable as Roastable));
  // Use the roaster's mass scale instead of the user's profile mass scale
  const startingMass = massToGrams(selectedRoaster.massScale, queueItem.startingMass);

  return {
    id,
    profile: {
      data: [
        {
          temperatures: recordedTemps[0].join(';'),
          label: 'Bean'
        },
        {
          temperatures: recordedTemps[1].join(';'),
          label: selectedRoaster.tcLabels.tc2!
        },
        {
          temperatures: recordedTemps[2].join(';'),
          label: selectedRoaster.tcLabels.tc3!
        },
        {
          temperatures: recordedTemps[3].join(';'),
          label: selectedRoaster.tcLabels.tc4!
        },
        {
          temperatures: recordedTemps[4].join(';'),
          label: 'Heating Rate'
        }
      ],
      burner,
      corrected_hr: true,
      events: roastEvents,
      times: recordedTimes
    },
    device_type: deviceType,
    notes: roastNotes,
    roaster: selectedRoaster.roasterId,
    start_mass: startingMass,
    roastable: roastable.id,
    components: roastable.components,
    timestamp: Date.now(),
    location: parseInt(selectedLocation)
  };
};
